import React, { useState } from "react"; 
import {  Select } from "antd";
import { wtrHarvesters } from "../../../../data";
import BoreholeTable from "../../../water-harvesting/boreholes/BoreholeTable";
import DamsTable from "../../../water-harvesting/dams/DamsTable";
import WaterPansTable from "../../../water-harvesting/water-pans/WaterPansTable";
import { useSelector } from "react-redux";

function WtrStorage() {
  const [selectId, setSelectId] = useState("Boreholes");
  const {  activeObjPathCard } = useSelector((state) => ({ 
    activeObjPathCard: state.obj.activeObj["pathwayCard"],
  }));
  return (
    <>
      <div className="flex justify-between">
        <div></div>
        <div className="flex items-center justify-end w-[20%]">
          <Select
            className=""
            allowClear
            style={{
              width: "100%",
            }}
            options={
              wtrHarvesters?.length > 0 &&
              wtrHarvesters?.map((item) => ({
                value: item?.value,
                label: item?.label,
              }))
            }
            value={selectId}
            onChange={(value) => setSelectId(value)}
            placeholder="Select"
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              (option?.label?.toLocaleLowerCase() ?? "").includes(
                input?.toLocaleLowerCase()
              )
            }
          />
        </div>
      </div>
      {selectId === "Boreholes" ? (
        <BoreholeTable pathwayId={activeObjPathCard?.irrigationPathwayId}/>
      ) : selectId === "Dams" ? (
        <DamsTable pathwayId={activeObjPathCard?.irrigationPathwayId}/>
      ) : selectId === "Water_Pans" ? (
        <WaterPansTable pathwayId={activeObjPathCard?.irrigationPathwayId}/>
      ) : null}
    </>
  );
}

export default WtrStorage;
